import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { first } from 'rxjs/operators';

import { NotificationService, SpiderService, UserService } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-spider-account-detail',
  templateUrl: './spider-account-detail.component.html',
  styleUrls: []
})
export class SpiderAccountDetailComponent implements OnInit {

  account: any = {}; //SpiderAccount
  loaded = false;
  loading = true;
  processing = false;

  sourceList = {"JP6969":5, "PAY365":7};

  constructor(private route: ActivatedRoute,
    private router: Router,
    private userSvc: UserService,
    private spiderSvc: SpiderService,
    private notification: NotificationService,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    let id = this.route.snapshot.paramMap.get('id');
    this.loadDetail(id);
  }


  save() {
    this.processing = true;
    if (confirm("Are you sure to update this account?")) {
      this.spiderSvc.updateAccount(this.account).subscribe(data => {
        if (data !== null) {
          if (data.status == 1) {
            this.notification.showSuccess("Account updated successfully!", "Update Account");
            this.modalService.dismissAll();
          } else {
            this.notification.showError(data.msg, "Fail update");
          }

        } else {
          this.notification.showError("Failed to update account, please try again later.", "Fail update");
        }
      });
      this.processing = false;
    } else {
      this.processing = false;
    }
  }

  back() {
    this.router.navigate(['/dashboard/spider/account']);
  }

  private loadDetail(id){
    this.spiderSvc.getAccount(id).subscribe(data => {
      this.account = data
      this.loaded = true;
      this.loading = false;
    });
  }
}
